// src/pages/mytg.ts —— 账号区「Telegram ID」个人设置（0049，06 C-33 ⑥）：PUT /api/admin/me/telegram-id {telegram_id:string|null}，任何已登录管理员可用。
// 用途：广告推送「发给我预览」的接收方（admins.telegram_id）。留空提交 = null（解除）。成功后刷新 /me（若后端回显 telegram_id 则表单下次预填）
import { ApiError } from '../../../shared/src/api/client';
import type { RouteKey } from '../../../shared/src/api/routes';
import { openForm } from '../domains/table';
import { str, type AdminCtx } from '../domains/types';
import { bcCall } from './broadcast.contract';
import type { FormDef, FormVals } from './types';
import { LOCAL_FORM_CODE } from './ui';

const TG_ID_RE = /^\d{5,20}$/;
const ROUTE = 'PUT /api/admin/me/telegram-id' satisfies RouteKey;

// 表单红条本地文案（同 ui.localErr 口径）
const formErr = (message: string): ApiError => new ApiError({ code: LOCAL_FORM_CODE, status: 0, message, data: {}, route: ROUTE });

// 去空白；空串 → null（解除）；非法 → undefined
export function telegramIdOf(v: FormVals): string | null | undefined {
  const raw = String(v['telegram_id'] ?? '').replace(/\s+/g, '');
  if (raw === '') return null;
  return TG_ID_RE.test(raw) ? raw : undefined;
}

export function myTgForm(ctx: AdminCtx): FormDef {
  const t = ctx.t;
  const me = ctx.host.state.sh.me;
  return {
    title: str(t, 'myTgTitle'),
    tip: str(t, 'myTgTip'),
    fields: [{ k: 'telegram_id', label: str(t, 'myTgLabel'), type: 'text', wide: true, optional: true, placeholder: str(t, 'myTgPh') }],
    init: { telegram_id: me?.telegram_id ?? '' },
    validate: (v, d) => (telegramIdOf(v) === undefined ? str(d, 'myTgErr') : ''),
    submit: async (c, v) => {
      const telegram_id = telegramIdOf(v);
      if (telegram_id === undefined) throw formErr(str(c.gp.ui.dict(), 'myTgErr'));
      try {
        await bcCall(c, ROUTE, { body: { telegram_id } });
      } catch (e) {
        // 4220（服务端格式校验）→ 本地文案
        if (e instanceof ApiError && e.code === 4220) throw formErr(str(c.gp.ui.dict(), 'myTgErr'));
        throw e;
      }
      c.gp.ui.toast(str(c.gp.ui.dict(), telegram_id === null ? 'myTgCleared' : 'myTgSaved'));
      void c.gp.session.refreshMe();
    },
  };
}

export function openMyTg(ctx: AdminCtx): void {
  openForm(ctx, myTgForm(ctx));
}
